import React, { createContext, useState, useContext, useEffect } from 'react';
import { tutoresApi, usuariosApi } from '../services/api';
import { getSocket } from '../services/socket';
import { useAuth } from '../metodos/AuthContext';
import { Tutor } from '../objetos/objeto_tutor'; // Asegúrate de que la ruta es correcta
import { isClientes } from '../config/constants';
import { Cliente } from '../objetos/objeto_cliente';

// Crear el contexto
const UsersContext = createContext();

// Hook personalizado para usar el contexto
export function useUsers() {
    return useContext(UsersContext);
}

// Proveedor del contexto
export function UsersProvider({ children }) {
    const [usuario, setUsuario] = useState(null);
    const [loadingUsuario, setLoading] = useState(true);
    const [errorUsuario, setError] = useState(null);

    // Obtener datos del usuario actual
    const { currentUserData } = useAuth();

    // Cargar usuarios y configurar escuchas de WebSocket
    useEffect(() => {
        
        if (currentUserData === undefined) return;

        // Función para reiniciar el estado
        const resetState = () => {
            setUsuario(null);
            setLoading(false);
            setError(null);
        };

        // Verificar si currentUserData existe y tiene datos
        if (!currentUserData || !currentUserData.data || !currentUserData.data.uid) {
            resetState();
            return;
        }

        const uidUsuario = currentUserData.data.uid;
        //console.log("cargando data de cache",currentUserData.data.uid);
        //console.log("Usuario UID cargado", uidUsuario);

        const cargarUsuarios = async () => {
            try {
                setLoading(true);
                const response = await usuariosApi.getById(uidUsuario);

                //obtener usuario o cliente
                let userData;
                if(isClientes){
                    userData = Cliente.fromJson(response.data, uidUsuario);
                } else{
                    userData = Tutor.fromJson(response.data, uidUsuario);
                }

                setUsuario(userData);
                setError(null);
            } catch (err) {
                console.log("error al cargar de suuarios");
                setError('Error al cargar usuarios');
                console.error(err);
                setUsuario(null);
            } finally {
                setLoading(false);
            }
        };

        cargarUsuarios();

    
        
    }, [currentUserData]);

    //recargar usuario
    const recargarUsuario = async () => {
        if (!currentUserData || !currentUserData.data || !currentUserData.data.uid) {
            return;
        }

        const uidUsuario = currentUserData.data.uid;
        
        try {
            setLoading(true);
            const response = await usuariosApi.getById(uidUsuario);

            //obtener usuario o cliente
            let userData;
            if(isClientes){
                userData = Cliente.fromJson(response.data, uidUsuario);
            } else{
                userData = Tutor.fromJson(response.data, uidUsuario);
            }

            setUsuario(userData);

            setError(null);
            //console.log("cargando usuario ",tutorData);
            return userData; // Devuelve los datos actualizados
        } catch (err) {
            console.error("Error al recargar usuario:", err);
            setError('Error al cargar usuarios');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    //recargar usuario de forma local
    const updateUsuarioLocal = (nuevosDatos) =>{
        setUsuario(prev => {
            if (!prev) return prev;
            return { ...prev, ...nuevosDatos };
        });
    }
  
    // Valor que se proporcionará a los componentes
    const value = {
        usuario,
        loadingUsuario,
        errorUsuario,
        recargarUsuario,
        updateUsuarioLocal,
    };
  
    return (
        <UsersContext.Provider value={value}>
            {children}
        </UsersContext.Provider>
    );
}